import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCaretRightDouble24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconCaretRightDouble24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M12.53 4.47a.75.75 0 0 0-1.06 1.06L17.94 12l-6.47 6.47a.75.75 0 1 0 1.06 1.06l7-7 .53-.53-.53-.53zm-7 0a.75.75 0 0 0-1.06 1.06L10.94 12l-6.47 6.47a.75.75 0 1 0 1.06 1.06l7-7 .53-.53-.53-.53z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCaretRightDouble24);
